import * as actions from "./actionTypes";
import axios from "../../axios_call";
import Moment from "moment";
import { BASE_URL } from "../../components/Helpers/helpers";

export const authStart = () => ({
  type: actions.AUTH_START,
});

export const authFail = (error) => {
  return {
    type: actions.AUTH_FAIL,
    error: error,
  };
};

export const authSuccess = (data) => {
  return {
    type: actions.AUTH_SUCCESS,
    data: data,
  };
};

export const authLogout = () => {
  localStorage.clear();
  return {
    type: actions.AUTH_LOGOUT,
  };
};
export const setUserId = (userId) => ({
  type: "SET_USER_ID",
  payload: userId,
});

export const checkAuthTimeout = (expiresIn) => {
  return (dispatch) => {
    setTimeout(() => {
      dispatch(authLogout());
    }, expiresIn);
  };
};

export const userLogin = (EmailAddress, Password) => {
  return (dispatch) => {
    dispatch(authStart());
    return axios
      .post(`${BASE_URL}/user/login`, {
        EmailAddress: EmailAddress,
        Password: Password,
      })
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem(
            "userDetail",
            JSON.stringify(response.data.data),
          );
          localStorage.setItem(
            "currentLoginUserId",
            JSON.stringify(response.data.data.UserID),
          );
          localStorage.setItem("OrganisationID", "");
          return dispatch(authSuccess(response.data.data));
        } else {
          dispatch(authLogout());
          return dispatch(authFail(response.message));
        }
      });
  };
};

export const userRegister = (
  OrganisationRole,
  FirstName,
  LastName,
  EmailAddress,
  Password,
  ConfirmPassword,
) => {
  return (dispatch) => {
    dispatch(authStart());

    return axios
      .post(`${BASE_URL}/user/register`, {
        OrganisationRole,
        FirstName,
        LastName,
        EmailAddress,
        Password,
        ConfirmPassword,
      })
      .then((response) => {
        if (response.status === 200) {
          const message = response.data.message || "Registration successful!";
          dispatch(authSuccess(message));
          return { status: 200, message };
        } else {
          const errorMessage = response.data.message || "Registration failed.";
          dispatch(authFail(errorMessage));
          return { status: response.status, message: errorMessage };
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred. Please try again.";
        dispatch(authFail(errorMessage));
        return Promise.reject(new Error(errorMessage));
      });
  };
};

export const userForgot = (EmailAddress) => {
  return (dispatch) => {
    dispatch(authStart());
    return axios
      .post(`${BASE_URL}/user/forgot-password`, { EmailAddress })
      .then((response) => {
        if (response.status === 200) {
          return dispatch(authSuccess(response.data.message));
        } else {
          dispatch(authFail(response.data.message));
          return response;
        }
      })
      .catch((error) => {
        dispatch(authFail(error.message));
        throw error;
      });
  };
};

export const userOTP = (EmailAddress) => {
  return (dispatch) => {
    dispatch(authStart());
    return axios
      .post(`${BASE_URL}/user/forgot-password`, { EmailAddress })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          localStorage.setItem(
            "userDetail",
            JSON.stringify(response.data.data),
          );
          dispatch(authSuccess(response.data.message));
          return response;
        } else {
          dispatch(authFail(response.data.message));
          return response;
        }
      })
      .catch((error) => {
        dispatch(authFail(error.message));
        throw error;
      });
  };
};
export const userChangePassword = (id, Password, ConfirmPassword) => {
  return (dispatch) => {
    dispatch(authStart());

    return axios
      .post(`${BASE_URL}/user/change_password/${id}`, {
        Password: Password,
        ConfirmPassword: ConfirmPassword,
      })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          localStorage.setItem(
            "userDetail",
            JSON.stringify(response.data.data),
          );
          dispatch(authSuccess(response.data.message));
          return response;
        } else {
          dispatch(authFail(response.data.message));
          return response;
        }
      })
      .catch((error) => {
        dispatch(authFail(error.message));
        throw error;
      });
  };
};
export const authCheckState = () => {
  return (dispatch) => {
    try {
      const userDetail = JSON.parse(localStorage.getItem("userDetail"));
      if (!userDetail) {
        dispatch(authLogout());
        return;
      }
      const now = Moment(new Date());
      const end = Moment(userDetail.tokenExpiration);
      if (end.isBefore(now)) {
        dispatch(authLogout());
      } else {
        const now = Moment(new Date());
        const end = Moment(userDetail.tokenExpiration);
        if (end.isBefore(now)) {
          dispatch(authLogout());
        } else {
          const duration = Moment.duration(end.diff(now));
          const remainingSeconds = duration.asSeconds();

          dispatch(checkAuthTimeout(remainingSeconds * 1000));
        }
      }
    } catch (error) {
      console.error("Error parsing user details from localStorage:", error);
      dispatch(authLogout());
    }
  };
};
